var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isVisibleOnFeatureSwitch)?_c('div',{ref:"popperReference",class:[
		'btn-action-ribbon-menu',
		_vm.expanded && 'is-open',
		_vm.disabled && 'is-disabled',
		_vm.disabled
			? 'is-disabled'
			: _vm.isLoading
			? 'is-disabled'
			: _vm.hasLoaded
			? 'is-disabled'
			: '',
		_vm.isLoading && 'is-loading',
		_vm.hasLoaded && 'has-loaded'
	],attrs:{"disabled":_vm.disabled,"tabindex":"0"}},[_c('div',{staticClass:"btn-action-ribbon-menu__btn-container",on:{"click":_vm.showOptions}},[_c('ButtonActionRibbon',{attrs:{"labelText":_vm.labelText,"iconClassName":_vm.iconMenuClassName}}),_c('BtnTrigger',{staticClass:"btn-action-ribbon-menu__trigger",attrs:{"expanded":_vm.expanded}})],1),_c('PopperPosition',{attrs:{"trackedRefName":"popperReference","popoverRefName":"popper","placement":"bottom-start","popperVisible":_vm.expanded,"strategy":"fixed"},on:{"popperMinWidthChanged":_vm.setpopperMinWidth}}),_c('Menu',{ref:"popper",attrs:{"options":_vm.options,"visible":_vm.expanded,"minWidth":_vm.popperMinWidth},on:{"change":_vm.onSelectOption}}),_c('ButtonProgress',{attrs:{"isLoading":_vm.isLoading,"hasLoaded":_vm.hasLoaded,"hasError":_vm.hasError,"errorMessage":_vm.errorMessage,"isActionRibbon":true}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }